import { ApiEndpoint, ApiEndpointsForResource } from "/shortcodes";
import * as React from 'react';
export default {
  ApiEndpoint,
  ApiEndpointsForResource,
  React
};